/**
 * Initializes the preferred currency from the account or cookies
 * 1. Logged in user - Gets the currency from the account
 * 2. Guest - Gets the currency from the cookies, if not set, gets the default currency (based on selected locale)
 */
import { actionTypes as localizationActions } from '~/store/localization';
import { actionTypes as userActions } from '~/store/user';

export default function (context) {
    const PREFERRED_CURRENCY_STORAGE_KEY = 'mc_preferred_currency';
    const { isLoggedIn, userCurrency, defaultCurrency, preferredCurrency } = context.store.getters;

    if (preferredCurrency) {
        return;
    }

    let currency;

    if (isLoggedIn) {
        currency = userCurrency;
    } else {
        currency = context.app.$cookies.get(PREFERRED_CURRENCY_STORAGE_KEY) || defaultCurrency;
    }

    if (currency) {
        context.store.dispatch(localizationActions.SET_PREFERRED_CURRENCY, currency);
    }

    context.store.subscribeAction({
        after: action => {
            if (action.type === localizationActions.SET_PREFERRED_CURRENCY) {
                const currency = action.payload;

                // Set cookies even if logged in to avoid unexpected currency changes for users logging out
                context.app.$cookies.set(PREFERRED_CURRENCY_STORAGE_KEY, currency);

                // Save currency to user profile if logged in
                if (context.store.getters.isLoggedIn && context.store.getters.userCurrency !== currency) {
                    context.store.dispatch(userActions.SAVE_ME, { currency }).catch(err => {
                        context.$sentry.captureException(err);
                    });
                }
            }

            if (
                action.type === userActions.LOGIN &&
                context.store.getters.userCurrency !== context.store.getters.preferredCurrency
            ) {
                context.store
                    .dispatch(localizationActions.SET_PREFERRED_CURRENCY, context.store.getters.userCurrency)
                    .catch(err => {
                        context.$sentry.captureException(err);
                    });
            }
        },
    });
}
